<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="money-collection-dashboard">
  <div class="container-fluid mt-3">

    <!-- Filters Section -->
    <form
      #cf="ngForm"
      novalidate
      (keydown.enter)="getCollectionTrackerReport()"
      class="formborder"
    >
      <div class="row align-items-end">
        <!-- Single-select Employee Dropdown -->
        <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
          <span>Select Employee</span>
          <select
            name="EmpId"
            id="EmpId"
            [(ngModel)]="EmpId"
            (change)="onEmployeeChange()"
            class="form-control input-text-css"
          >
            <option value="0">All Employee</option>
            <option *ngFor="let emp of EmployeeList" [value]="emp.EmpId">
              {{ emp.EmpName }}
            </option>
          </select>
        </div>

        <!-- Multi-select Branch -->
        <div class="col-lg-2 col-md-3 col-sm-6 mb-2 multiselect-field">
          <span>Select Branch</span>
          <ng-multiselect-dropdown
            class="non-starter-multiselect"
            name="SelectedBranches"
            id="SelectedBranches"
            [(ngModel)]="SelectedBranches"
            [placeholder]="'Select Branch'"
            [settings]="branchDropdownSettings"
            [data]="BranchesList"
            (onDropDownClose)="onFilterChange()"
            (onSelect)="onFilterChange()"
            (onDeSelect)="onFilterChange()"
            (onSelectAll)="onFilterChange()"
            (onDeSelectAll)="onFilterChange()"
          >
          </ng-multiselect-dropdown>
        </div>

        <!-- From Date -->
        <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
          <span class="required-lable">From Date</span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="pickerFrom"
              dateConvert
              placeholder="DD/MM/YYYY"
              name="DateFrom"
              id="DateFrom"
              class="form-control input-text-css"
              [(ngModel)]="DateFrom"
              required
            />
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </div>
        </div>

        <!-- To Date -->
        <div class="col-lg-2 col-md-3 col-sm-6 mb-2">
          <span class="required-lable">To Date</span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="pickerTo"
              dateConvert
              placeholder="DD/MM/YYYY"
              name="DateTo"
              id="DateTo"
              class="form-control input-text-css"
              [(ngModel)]="DateTo"
              required
            />
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="col-lg-4 col-md-12 mb-2 d-flex align-items-center justify-content-end" style="gap: 0.35rem;">
          <button
            type="button"
            (click)="getCollectionTrackerReport()"
            class="btn button-btn"
            style="padding: 0.4rem 0.7rem; font-size: 0.75rem; white-space: nowrap;"
            [disabled]="!cf.form.valid"
          >
            <i class="fa fa-search mr-1"></i> Search
          </button>
          <button
            type="button"
            (click)="resetFilters()"
            class="btn button-btn"
            style="padding: 0.4rem 0.7rem; font-size: 0.75rem; white-space: nowrap;"
          >
            <i class="fa fa-undo mr-1"></i> Reset
          </button>
          <button
            type="button"
            (click)="exportToExcel()"
            class="btn button-btn"
            style="padding: 0.4rem 0.7rem; font-size: 0.75rem; white-space: nowrap;"
          >
            <i class="fa fa-file-excel mr-1"></i> Export
          </button>
        </div>
      </div>
    </form>

    <!-- Header KPI Summary Cards -->
    <div class="dashboard-header">
      <div class="header-card total-collection">
        <div class="header-label header-badge positive">
          <i class="fa fa-route mr-1"></i> TOTAL VISITS
        </div>
        <div class="header-value">{{ getTotalVisitsCount() }}</div>
      </div>

      <div class="header-card active-transactions">
        <div class="header-label header-badge live">
          <i class="fa fa-building mr-1"></i> BRANCHES COVERED
        </div>
        <div class="header-value">{{ getUniqueBranchesCount() }}</div>
      </div>

      <div class="header-card total-collection">
        <div class="header-label header-badge positive">
          <i class="fa fa-user-tie mr-1"></i> EMPLOYEES REPORTING
        </div>
        <div class="header-value">{{ getUniqueEmployeesCount() }}</div>
      </div>
    </div>

    <!-- Actions & Filter Bar -->
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div>
        <button type="button" class="btn font-size-12 button-btn" (click)="expandAll()">
          <i class="fa fa-plus-square mr-1"></i> Expand All
        </button>
        <button type="button" class="btn font-size-12 button-btn ml-2" (click)="collapseAll()">
          <i class="fa fa-minus-square mr-1"></i> Collapse All
        </button>
      </div>

      <div style="min-width: 250px;">
        <input
          type="text"
          id="FilterInputSearch"
          [(ngModel)]="SearchText"
          name="SearchText"
          placeholder="What're you searching for?"
          class="form-control input-text-css"
        />
      </div>
    </div>

    <!-- Dashboard Cards Hierarchy (Employee -> Branch -> Visits Data Table) -->
    <div class="dashboard-cards mb-4">
      <div
        class="dashboard-card mb-3"
        *ngFor="let empGroup of groupedEmployeeList; let empIdx = index; trackBy: trackByEmp"
        [class.expanded]="isEmpOpen(empGroup, empIdx)"
      >
        <!-- Level 1: Employee Header Bar -->
        <div
          class="card-header cursor-pointer d-flex align-items-center justify-content-between p-3"
          (click)="toggleEmp(empGroup, empIdx, $event)"
        >
          <div class="card-title d-flex align-items-center mb-0">
            <i class="fa fa-user-circle mr-2 text-white" style="font-size: 1.25rem;"></i>
            <div class="card-text">
              <span class="card-name text-white font-weight-bold" style="font-size: 1.05rem; letter-spacing: 0.3px;">{{ empGroup.Employee_Name }}</span>
              <span class="text-white-50 ml-2 font-weight-bold">({{ empGroup.branches.length }} Branch{{ empGroup.branches.length > 1 ? 'es' : '' }})</span>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="card-vouchers mr-3">
              <span class="badge badge-light text-dark font-weight-bold px-3 py-2" style="font-size: 0.85rem;">
                <i class="fa fa-walking mr-1"></i> {{ empGroup.Total_Count }} Total Visits
              </span>
            </div>
            <div class="btn-toggle-expand text-white font-weight-bold ml-2" style="font-size: 1.1rem;">
              <i class="fa" [ngClass]="isEmpOpen(empGroup, empIdx) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
          </div>
        </div>

        <!-- Level 2: Branch Children Container -->
        <div class="card-body p-3 bg-light" *ngIf="isEmpOpen(empGroup, empIdx)">
          <div
            class="nested-branch-card mb-3"
            *ngFor="let branchGroup of empGroup.branches; let branchIdx = index; trackBy: trackByBranch"
            [class.expanded]="isBranchOpen(empGroup, branchGroup, empIdx, branchIdx)"
          >
            <!-- Branch Header Bar -->
            <div
              class="branch-header cursor-pointer d-flex align-items-center justify-content-between p-3 rounded"
              (click)="toggleBranchNode(empGroup, branchGroup, empIdx, branchIdx, $event)"
            >
              <div class="d-flex align-items-center">
                <i class="fa fa-building mr-2 text-white" style="font-size: 1rem;"></i>
                <span class="font-weight-bold text-white ml-1" style="font-size: 0.98rem; letter-spacing: 0.2px;">{{ branchGroup.Branch_Name }}</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="badge badge-light text-dark px-3 py-2 mr-3 font-weight-bold" style="font-size: 0.82rem;">
                  <i class="fa fa-clipboard-check mr-1"></i> {{ branchGroup.Total_Count }} Visits
                </span>
                <span class="text-white font-weight-bold mr-1" style="font-size: 1rem;">
                  <i class="fa" [ngClass]="isBranchOpen(empGroup, branchGroup, empIdx, branchIdx) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>
              </div>
            </div>

            <!-- Level 3: Visits Data Table -->
            <div class="branch-body p-2 bg-white rounded-bottom border border-top-0" *ngIf="isBranchOpen(empGroup, branchGroup, empIdx, branchIdx)" (click)="$event.stopPropagation()">
              <div class="table-responsive">
                <table class="table table-bordered table-hover font-size-12 mb-0 custom-tracker-table" (click)="$event.stopPropagation()">
                  <thead>
                    <tr class="grid-header-row">
                      <th style="width: 40px; text-align: center;">#</th>
                      <th>Borrower Name</th>
                      <th>Loan Number</th>
                      <th>Application No</th>
                      <th>Check-In Time</th>
                      <th>Check-In GPS & Remark</th>
                      <th style="text-align: center; width: 110px;">Check-In Photo</th>
                      <th>Check-Out Time</th>
                      <th>Check-Out GPS & Remark</th>
                      <th style="text-align: center; width: 110px;">Check-Out Photo</th>
                      <th style="text-align: center; width: 120px;">Total Time Taken</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let child of getTrackerDetailsForParent(branchGroup.parentSummary); let j = index; trackBy: trackByChild">
                      <td style="text-align: center; vertical-align: middle;" class="font-weight-bold text-muted">{{ j + 1 }}</td>
                      <td style="vertical-align: middle;" class="font-weight-bold text-primary">{{ child.Borrower_Name }}</td>
                      <td style="vertical-align: middle;" class="text-nowrap font-weight-bold">
                        <span *ngIf="child.Loan_Number" class="badge badge-secondary px-2 py-1">{{ child.Loan_Number }}</span>
                        <span *ngIf="!child.Loan_Number" class="text-muted">-</span>
                      </td>
                      <td style="vertical-align: middle;" class="text-nowrap font-weight-bold">
                        <span *ngIf="child.Application_No" class="badge badge-light border text-dark px-2 py-1">{{ child.Application_No }}</span>
                        <span *ngIf="!child.Application_No" class="text-muted">-</span>
                      </td>
                      <td style="vertical-align: middle;" class="text-nowrap">
                        <i class="far fa-clock text-info mr-1" *ngIf="child.CheckIn_On"></i>
                        {{ formatDateTime(child.CheckIn_On) }}
                      </td>
                      <td style="vertical-align: middle;">
                        <div class="font-weight-medium mb-1">{{ child.CheckIn_Remark || '-' }}</div>
                        <div *ngIf="child.CheckIn_LatLong">
                          <a
                            [href]="'http://maps.google.com/maps?q=' + child.CheckIn_LatLong"
                            target="_blank"
                            class="gps-link badge badge-light border text-primary px-2 py-1 mt-1"
                            [title]="'GPS: ' + child.CheckIn_LatLong"
                            (click)="$event.stopPropagation()"
                          >
                            <i class="fa fa-map-marker-alt text-danger mr-1"></i>
                            {{ getAddress(child.CheckIn_LatLong) }}
                          </a>
                        </div>
                      </td>
                      <td style="text-align: center; vertical-align: middle;">
                        <div *ngIf="child.CheckIn_Img" class="image-thumb-container">
                          <img
                            [src]="docBaseUrl + child.CheckIn_Img"
                            onerror="this.src='assets/images/Doc_Image.jpg';"
                            class="img-thumbnail cursor-pointer photo-preview-thumb"
                            style="width: 42px; height: 42px; object-fit: cover; border-radius: 6px;"
                            (click)="openImageModal(child.CheckIn_Img, child.Application_No, 'Check-In Photo'); $event.stopPropagation()"
                            title="Click to view full photo"
                          />
                        </div>
                        <span *ngIf="!child.CheckIn_Img" class="text-muted">-</span>
                      </td>
                      <td style="vertical-align: middle;" class="text-nowrap">
                        <i class="far fa-clock text-success mr-1" *ngIf="child.CheckOut_On"></i>
                        {{ formatDateTime(child.CheckOut_On) }}
                      </td>
                      <td style="vertical-align: middle;">
                        <div class="font-weight-medium mb-1">{{ child.CheckOut_Remark || '-' }}</div>
                        <div *ngIf="child.CheckOut_LatLong">
                          <a
                            [href]="'http://maps.google.com/maps?q=' + child.CheckOut_LatLong"
                            target="_blank"
                            class="gps-link badge badge-light border text-primary px-2 py-1 mt-1"
                            [title]="'GPS: ' + child.CheckOut_LatLong"
                            (click)="$event.stopPropagation()"
                          >
                            <i class="fa fa-map-marker-alt text-danger mr-1"></i>
                            {{ getAddress(child.CheckOut_LatLong) }}
                          </a>
                        </div>
                      </td>
                      <td style="text-align: center; vertical-align: middle;">
                        <div *ngIf="child.CheckOut_Img" class="image-thumb-container">
                          <img
                            [src]="docBaseUrl + child.CheckOut_Img"
                            onerror="this.src='assets/images/Doc_Image.jpg';"
                            class="img-thumbnail cursor-pointer photo-preview-thumb"
                            style="width: 42px; height: 42px; object-fit: cover; border-radius: 6px;"
                            (click)="openImageModal(child.CheckOut_Img, child.Application_No, 'Check-Out Photo'); $event.stopPropagation()"
                            title="Click to view full photo"
                          />
                        </div>
                        <span *ngIf="!child.CheckOut_Img" class="text-muted">-</span>
                      </td>
                      <td style="text-align: center; vertical-align: middle;" class="text-nowrap font-weight-bold">
                        <span *ngIf="child.Total_Time_Taken && child.Total_Time_Taken !== '00:00:00'" class="badge badge-info px-2 py-1" style="font-size: 0.8rem;">
                          <i class="far fa-hourglass mr-1"></i> {{ child.Total_Time_Taken }}
                        </span>
                        <span *ngIf="!child.Total_Time_Taken || child.Total_Time_Taken === '00:00:00'" class="badge badge-light border text-muted px-2 py-1" style="font-size: 0.8rem;">
                          {{ child.Total_Time_Taken || '-' }}
                        </span>
                      </td>
                    </tr>

                    <tr *ngIf="getTrackerDetailsForParent(branchGroup.parentSummary).length === 0">
                      <td colspan="11" style="text-align: center; padding: 20px;" class="text-muted">
                        <i class="fa fa-info-circle mr-1"></i> No visit details found for this branch.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="groupedEmployeeList.length === 0" class="text-center py-5 bg-white rounded border text-muted">
        <i class="fa fa-folder-open fa-2x mb-2 text-muted"></i>
        <div>No collection tracker records found.</div>
      </div>
    </div>

  </div>

<!-- Image Modal Popup -->
<div *ngIf="selectedImageSrc" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5); z-index: 1050;">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header py-2" style="background-color: var(--theme-primary, #008080); color: white;">
        <h6 class="modal-title font-weight-bold mb-0">
          <i class="fa fa-image mr-1"></i> {{ selectedImageTitle }}
        </h6>
        <button type="button" class="close text-white" (click)="closeImageModal()">&times;</button>
      </div>
      <div class="modal-body text-center p-3">
        <img
          [src]="selectedImageSrc"
          onerror="this.src='assets/images/Doc_Image.jpg';"
          class="img-fluid rounded border shadow-sm"
          style="max-height: 70vh; object-fit: contain;"
        />
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn font-size-12 button-btn" (click)="closeImageModal()">Close</button>
      </div>
    </div>
  </div>
</div>
</div>
